import { UserService } from 'SERVICES';

// (string | number) => void
export default (orderId) => {
  const pdfUrl = UserService.getPdf(orderId);
  window.open(pdfUrl, '_blank');
};
